import { Pipe, PipeTransform } from '@angular/core';
import type { EavComputedAttributeTokenInterface } from '@zaoblako/shared/modules/eav/dtos/eav-computed-attribute-token.dto';

@Pipe({
  name: 'eavComputedExpression',
  standalone: true
})
export class EavComputedExpressionPipe implements PipeTransform {
  public transform(
    expression: string | null | undefined,
    tokens: EavComputedAttributeTokenInterface[] | null | undefined
  ): string {
    if (!expression) {
      return '';
    }

    if (!tokens?.length) {
      return expression;
    }

    const tokensSortedByLength = [...tokens].sort(
      (firstToken, secondToken) => secondToken.systemName.length - firstToken.systemName.length
    );

    return tokensSortedByLength.reduce((resultExpression, token) => {
      const escapedSystemName = this.escapeRegExp(token.systemName);
      return resultExpression.replace(new RegExp(escapedSystemName, 'g'), token.displayName);
    }, expression);
  }

  private readonly escapeRegExp = (value: string): string => {
    return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };
}
